"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Icon_1 = tslib_1.__importDefault(require("@ant-design/icons/lib/components/Icon"));
/**
 * [currency-eur](https://github.com/Templarian/MaterialDesign-SVG/blob/master/svg/currency-eur.svg) icon from [Material Design](https://github.com/Templarian/MaterialDesign)
 *
 * @author Google
 * @version 1.5.54
 */
function CurrencyEurIcon(props) {
    return React.createElement(Icon_1.default, tslib_1.__assign({ component: SVG }, props));
}
exports.default = CurrencyEurIcon;
var SVG = function () { return React.createElement("svg", { width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M15 18.5C12.5 18.5 10.32 17.08 9.24 15H15L16 13H8.58C8.53 12.67 8.5 12.34 8.5 12S8.53 11.33 8.58 11H15L16 9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.5 6.5 9H3L2 11H6.06C6 11.33 6 11.66 6 12S6 12.67 6.06 13H3L2 15H6.5C7.76 18.5 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z" })); };
